<template>
  <div class="config_item">
    <span
      v-if="field"
      class="item_field"
    >{{ field }}：</span>
    <div class="item_content">
      <slot />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    field: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.config_item {
  position: relative;
  margin-bottom: 12px;
  .item_field {
    display: inline-block;
    width: 98px;
    position: absolute;
    top: 4px;
    color: #666;
    line-height: 24px;
    text-align: right;
  }
  .item_content {
    position: relative;
    display: inline-block;
    left: 98px;
    margin: 0 16px;
  }
}
</style>
